import { render, staticRenderFns } from "./valveClampUpstream.vue?vue&type=template&id=173497fc&scoped=true"
import script from "./valveClampUpstream.vue?vue&type=script&lang=js"
export * from "./valveClampUpstream.vue?vue&type=script&lang=js"
import style0 from "./valveClampUpstream.vue?vue&type=style&index=0&id=173497fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173497fc",
  null
  
)

export default component.exports